import { SelectorListContext } from '@angular/compiler';
import { Component } from '@angular/core';
import { NgSelectOption } from '@angular/forms';
import { FileInfo } from 'src/app/shared/interfaces/file-info.interface';
import { SelectionModel } from 'src/app/shared/models/selection.model';

const mock: Array<FileInfo> = [
  {
    id: 1,
    name: 'example_file.pdf',
    size: 12000,
  },
  {
    id: 2,
    name: 'example_file_1.doc',
    size: 1200,
  },
  {
    id: 3,
    name: 'example_file_2.docx',
    size: 12000000,
  },
  {
    id: 4,
    name: 'example_file_3.pdf',
    size: 12520,
  },
  {
    id: 5,
    name: 'example_file_4.docx',
    size: 120,
  },
];

@Component({
  selector: 'app-account-files',
  templateUrl: './account-files.component.html',
  styleUrls: ['./account-files.component.scss'],
})
export class AccountFilesComponent {
  selectionModel = new SelectionModel<FileInfo>(true,[],(a,b) => a.id && b.id ? a.id === b.id : a === b);

  files: Array<FileInfo> = [...mock];

  constructor() {
    this.selectionModel.changed.subscribe(e => console.log(e));
  }

  getFileIconClass(fileType: string) {
    return `icon-file-${fileType.toLowerCase()}`;
  }

  getFileType(fileName: string) {
    return fileName.slice(fileName.lastIndexOf('.') + 1);
  }

  isAllSelected() {
    return this.files.every(e => this.selectionModel.isSelected(e))
  }

  setSelectionForAll(checked: boolean) {
    checked ? this.selectionModel.select(...this.files) : this.selectionModel.deselect(...this.files)
  }

}
